import React, { memo } from 'react';
import styled from 'styled-components';
import { BackgroundImage, Box, Flex } from 'pcln-design-system';
import ContentfulRichText from '../ContentfulRichText';
import { trimAssetUrl } from '../utils';
import ContentfulCallToAction from '../ContentfulCallToAction';
// Contentful Image API can accept only a max width and height of 4000
const IMAGE_API_DIMENSION_LIMIT = 4000;
const StyledBackgroundImage = /*#__PURE__*/styled(BackgroundImage).withConfig({
  displayName: "ContentfulBackgroundImage__StyledBackgroundImage",
  componentId: "sc-1cj1zk0-0"
})(["", ""], props => props.enableGradient && `
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2) 50%,
      rgba(0, 0, 0, 0.2) 50%
    ),
    url(${props.image});
  `);
function ContentfulBackgroundImage({
  asset,
  callToAction,
  children,
  className,
  desktopFocalPoint = 'center',
  enableGradient,
  fit = 'fill',
  format = 'webp',
  headline,
  headlineColor = 'text.lightest',
  headlineTextStyle,
  height,
  isMobile,
  mobileHeadline,
  mobileSubheadline,
  quality = 90,
  radius,
  subheadline,
  subheadlineColor = 'text.lightest',
  subheadlineTextStyle,
  width,
  ...props
}) {
  const file = asset?.file;
  const url = trimAssetUrl(file?.url);
  const imageParams = new URLSearchParams({
    ...(fit && {
      fit
    }),
    ...(desktopFocalPoint && {
      f: desktopFocalPoint
    }),
    ...(!url?.includes('.svg') && {
      fm: format
    }),
    ...(radius && {
      r: String(radius)
    }),
    ...(width && Number(width) <= IMAGE_API_DIMENSION_LIMIT && {
      w: String(width)
    }),
    ...(height && Number(height) <= IMAGE_API_DIMENSION_LIMIT && {
      h: String(height)
    }),
    q: String(quality)
  });
  const image = `https:${url}?${imageParams.toString()}`;
  const responsiveHeadline = isMobile && mobileHeadline ? mobileHeadline : headline;
  const responsiveSubheadline = isMobile && mobileSubheadline ? mobileSubheadline : subheadline;
  return React.createElement(StyledBackgroundImage, {
    className: className,
    image: image,
    enableGradient: enableGradient,
    height: height,
    ...props
  }, (headline || subheadline || callToAction) && React.createElement(Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    px: [3, null, null, 6]
  }, React.createElement(Box, {
    width: 1,
    maxWidth: '1280px'
  }, headline && React.createElement(ContentfulRichText, {
    color: headlineColor,
    body: responsiveHeadline,
    m: 0,
    textStyle: headlineTextStyle
  }), subheadline && React.createElement(ContentfulRichText, {
    color: subheadlineColor,
    body: responsiveSubheadline,
    m: 0,
    mb: [1, null, null, 2],
    pb: 1,
    textStyle: subheadlineTextStyle
  }), callToAction && React.createElement(ContentfulCallToAction, {
    variation: 'fill',
    ...callToAction
  }))), children);
}
export default memo(ContentfulBackgroundImage);